import { GUIDHelper } from "CommonScripts/guidHelper";

export class DesignItem {
    public id: string;
    public name: string;
    public textureKey: string;
    public jointKey: string;
    public patternId: number;
    public modelUrl: string;
    public environmentTimeInMinutes: number;
    public timestamp: Date;
    public snapshotImageUrl: string;

    constructor(
        { name, textureKey, jointKey, patternId, modelUrl, environmentTimeInMinutes, timestamp, snapshotImageUrl } : 
        { name: string, textureKey: string, jointKey: string, patternId: number, modelUrl: string, environmentTimeInMinutes: number, timestamp: Date, snapshotImageUrl: string }) {
        this.id = GUIDHelper.create();
        this.name = name;
        this.textureKey = textureKey;
        this.jointKey = jointKey;
        this.patternId = patternId;
        this.modelUrl = modelUrl;
        this.environmentTimeInMinutes = environmentTimeInMinutes;
        this.timestamp = timestamp;
        this.snapshotImageUrl = snapshotImageUrl;
    }
}